import React from 'react';
import axios from 'axios';
import urlBase from '../../url-base';


class LogoutPage extends React.Component {

  constructor(props) {
    super(props);

  }


  componentDidMount() {
    let access_token = window.localStorage.getItem('dental_t');

    axios.post(urlBase.loopBack + 'Accounts/logout?access_token=' + access_token)
      .then(() => {
        this.removeLocalStorage();
      })
      .catch(function () {
        this.removeLocalStorage();
      }.bind(this));
  }

  removeLocalStorage() {
    window.localStorage.removeItem('dental_t');
    window.localStorage.removeItem('dental_u');
    window.localStorage.removeItem('dental_y');
    window.localStorage.removeItem('dental_n');
    window.localStorage.removeItem('dental_i');
    window.location.href = urlBase.client+'panel';
  }

  render() {
    return (<span>&nbsp;</span>);
  }

  
}


export default LogoutPage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/LogoutPage.js
 **/